/*eslint-disable*/
import React, { useEffect, useState } from 'react'
import { Header, Segment } from 'semantic-ui-react'
import LoadingPlaceholder from '../../placeholderComponent/loadingPlaceholder'
import ReadAxios from '../../axiosComponent/read'
import ProductActionButton from './productActionButton'
import AgGridTable from '../../agGridComponent/agGridTable'
import Axios from 'axios';
import APP_CONSTANTS from '../../../config/constants';
import { productHeaders } from '../../../utils/constants/product.constants'
import { tableHeaders,tableMessage } from '../../../utils/constants/table.constants'
import { FEATURES } from '../../../utils/constants'


function ProductTable(props) {
    const [products, setproducts] = useState([])
    const [isLoaded, setisLoaded] = useState(false)
    const [isUpdated, setisUpdated] = useState(false)
    useEffect(() => {
        getJobcardTypes()
    }, [isUpdated])
    let getUpdate = (data) => {
        if (data) {
            setisUpdated(!isUpdated)
        }
    }
    let getJobcardTypes = () => {

        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')

        Axios.get(`${APP_CONSTANTS.BASE_URL}masters/psLineItem?customerNumber=${customerNo}&userId=${userId}&customer_no=${customerNo}&customerNo=${customerNo}&psType=1`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": token,
                "Access-Control-Allow-Origin": "*" 
            }
        }).then((response => {
            // console.log(response.data.data)
            setproducts(response.data.resultSet)
            setisLoaded(true)
        }))
        .catch(error => console.log(error))
        // ReadAxios({
        //     url: 'pslineitem/getPS',
        //     readItems: {
        //         type: [1]
        //     }
        // }).then((result) => {
        //     setproducts(result)
        //     setisLoaded(true)
        // })
    }
    let columnDefs = [
        { headerName: productHeaders.CODE, field: 'code', tooltipField: 'code', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: productHeaders.PRODUCT, field: 'name', tooltipField: 'name', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: productHeaders.CATEGORY, field: 'cat', tooltipField: 'cat', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: productHeaders.WEIGHT, field: 'weight', tooltipField: 'weight', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: productHeaders.PURCHASE_PRICE, field: 'purchase', tooltipField: 'purchase', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: productHeaders.SELLING_PRICE, field: 'selling', tooltipField: 'selling', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: productHeaders.GST, field: 'gst', tooltipField: 'gst', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: productHeaders.TDS, field: 'tds', tooltipField: 'tds', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: tableHeaders.CREATED_ON, field: 'con', tooltipField: 'con', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: tableHeaders.UPDATED_BY, field: 'cby', tooltipField: 'cby', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: tableHeaders.UPDATED_ON, field: 'uon', tooltipField: 'uon', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: tableHeaders.UPDATED_BY, field: 'uby', tooltipField: 'uby', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: tableHeaders.EDIT_DELETE, field: 'edit', cellRenderer: 'actionRenderer' },
    ]
    let rowData = []
    products.map((object, i) => {
        let temp = {}
        temp.code = object.psCode
        temp.name = object.psDescription
        temp.cat = object.categoryName
        temp.weight = object.unitNetWeight
        temp.purchase = object.purchasePrice
        temp.selling = object.sellingPrice
        temp.gst = object.gstPercentage
        temp.tds = object.tdsTaxSectionId
        temp.con = object.creationDate
        temp.cby = object.createdByName
        temp.uon = object.updationDate
        temp.uby = object.updatedByName
        temp.id = object.psId
        temp.customerNo = object.customerNo
        rowData[i] = temp
    })

    if (products.length === 0 && isLoaded === false) {
        return (
            <LoadingPlaceholder />
        )
    } else if (products.length === 0) {
        return (
            <Segment className="m-2">
                <center> <Header>{tableMessage.NO_RECORD}</Header></center>
            </Segment>
        )
    } else {
        return (
            <React.Fragment>
                <AgGridTable
                    columnDefs={columnDefs}
                    rowData={rowData}
                    searchValue={props.searchValue}
                    actionButton={ProductActionButton}
                    reload={getUpdate}
                    link="/add-products"
                    titleBarTitle="Products"
                    hiddenNewPopupBtn={true}
                    handleSearch={props.handleSearch}
                    hiddenImportPopupBtn={true}
                    showImport={true}
                    fileName="psLineItemProductMaster"
                    importSubUrl={'masters/import/psLineItemProductMaster'}
                    exportHidden={FEATURES.mastersExportDisabled()}
                    suppressExcelExport={FEATURES.mastersExportDisabled()}
                    suppressCsvExport={FEATURES.mastersExportDisabled()}
                />
            </React.Fragment>
            
        )
    }

}

export default ProductTable
